import { ReactNode, useState } from 'react';
import { Notification } from 'react-admin';
import { Box, Drawer, useMediaQuery, Theme } from '@mui/material';
import { AppSidebar, SIDEBAR_WIDTH } from './components/AppSidebar';
import { TopBar } from './components/TopBar';
import { brand } from './theme';

export const MyLayout = ({ children }: { children: ReactNode }) => {
  const isMobile = useMediaQuery((t: Theme) => t.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box sx={{ display: 'flex', width: '100%', maxWidth: '100vw', minHeight: '100vh', overflowX: 'clip', bgcolor: 'background.default' }}>
      {isMobile ? (
        <Drawer
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          ModalProps={{ keepMounted: true }}
          slotProps={{
            paper: {
              sx: {
                border: 'none',
                width: SIDEBAR_WIDTH,
                maxWidth: '88vw',
                bgcolor: 'transparent',
              },
            },
          }}
        >
          <AppSidebar onNavigate={() => setMobileOpen(false)} />
        </Drawer>
      ) : (
        <Box
          component="aside"
          sx={{
            position: 'relative',
            width: SIDEBAR_WIDTH,
            minWidth: SIDEBAR_WIDTH,
            height: '100vh',
            flexShrink: 0,
            zIndex: 2,
          }}
        >
          <Box sx={{ position: 'fixed', inset: '0 auto 0 0', width: SIDEBAR_WIDTH, height: '100dvh', overflowY: 'auto' }}>
            <AppSidebar />
          </Box>
        </Box>
      )}

      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', width: 0, maxWidth: '100%', minWidth: 0 }}>
        <TopBar onMenuClick={() => setMobileOpen(true)} />
        <Box
          component="main"
          sx={{
            flex: 1,
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            overflowX: 'clip',
            px: { xs: 1.5, sm: 2.25, md: 3, xl: 4 },
            pt: { xs: 2, md: 3 },
            pb: { xs: 3, md: 5 },
            backgroundImage: brand.pageGlow,
            backgroundAttachment: 'fixed',
          }}
        >
          {children}
        </Box>
      </Box>

      <Notification />
    </Box>
  );
};
